import * as THREE from 'three';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls'

const createDebugCamera = (scene, renderer, width, height) => {
  let debugCamera = new THREE.PerspectiveCamera(60, width/height);
  debugCamera.position.z = 10;
  let debugControls = new OrbitControls(debugCamera, renderer.domElement);
  return {debugCamera, debugControls}
};

const addGridHelpers = (scene) => {
  let grid = new THREE.GridHelper(200, 200, 0x00ff00, 0xffffff);
  let gridVertical = new THREE.GridHelper(200, 200, 0xff0000, 0xff00ff);
  gridVertical.rotateX(Math.PI / 2)
  scene.add(grid);
  scene.add(gridVertical)
};

const addCameraHelper = (scene, camera) => {
  let cameraHelper = new THREE.CameraHelper(camera);
  scene.add(cameraHelper)
};


export {
  createDebugCamera,
  addGridHelpers,
  addCameraHelper
}
